
export default {
  name: 'Star',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isOn: false,
    };
  },

  watch: {
    value(value) {
      this.isOn = value;
    },
  },

  mounted() {
    this.isOn = this.value;
  },

  methods: {
    toggle() {
      if (this.readOnly === true) return;
      this.isOn = !this.isOn;
      this.$emit('input', this.isOn);
    },
  },
};
